export class TreatmentModel {
  public currentBookingOptions: any = null; // current data of widget
  public widgetIdForRouting: string = null; // widget id
  public treatments: any = [];
  public treatmentList: any = [];
  public indexOfChosenTreatment: number = null;
  public indexOfChosenPrice: number = null;
  public practitioner: boolean = false;

  constructor(currentBookingOptions: any, widgetIdForRouting: string) {
    this.currentBookingOptions = currentBookingOptions;
    this.widgetIdForRouting = widgetIdForRouting;
  }
}

export class TreatmentStoreModel {
  public model$: any = null;
  public info$: any = null;
  public subscribtion: any = {
    booking$: null,
    data$: null
  };
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/treatment/treatment.model.ts